import type { ProjectType } from '@/api/project'
import type { ProjectContext } from '@/utils/projectContext'

/** GET .../customers/search 쿼리 파라미터 */
export interface MemberSearchRequestParams {
  projectType: ProjectType
  keyword: string
  parentCode?: string
}

/**
 * customers/search 쿼리 파라미터 생성.
 * BRAND일 때만 parentCode 포함 (없으면 에러).
 */
export function buildMemberSearchRequest(
  context: ProjectContext,
  keyword: string
): MemberSearchRequestParams {
  const trimmedKeyword = keyword.trim()
  const projectType = context.type

  const params: MemberSearchRequestParams = {
    projectType,
    keyword: trimmedKeyword
  }

  if (projectType === 'BRAND') {
    const parentCode = context.parentCode?.trim()
    if (!parentCode) {
      throw new Error('브랜드 프로젝트의 parentCode가 없습니다. 관리자에게 문의해 주세요.')
    }
    params.parentCode = parentCode
  }

  return params
}

export function buildMemberSearchQueryString(
  context: ProjectContext,
  keyword: string
): string {
  const request = buildMemberSearchRequest(context, keyword)
  const search = new URLSearchParams()
  search.set('projectType', request.projectType)
  search.set('keyword', request.keyword)
  if (request.parentCode) {
    search.set('parentCode', request.parentCode)
  }
  return search.toString()
}
